<video
  ref="landing_page_video"
  class="landing-page-video position-fixed top-0 start-0 w-100 h-100 object-fit-cover z-0"
  autoplay
  muted
  loop
  playsinline
></video>
